// extracted by mini-css-extract-plugin
module.exports = {"gallery":"a2c79c7e7d--gallery--_QjbR","transition":"a2c79c7e7d--transition--dqzso","slider_wrapper":"a2c79c7e7d--slider_wrapper--I6wxP"};